import { render, staticRenderFns } from "./enterpriseType.vue?vue&type=template&id=2e574d6a&scoped=true"
import script from "./enterpriseType.vue?vue&type=script&lang=js"
export * from "./enterpriseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e574d6a",
  null
  
)

export default component.exports